module.exports = __webpack_public_path__ + "static/img/qw_mob_04.4957ba59.png";